import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * Average Issue Age report route for CMP projects that do not have a board.
 */
export const cmpAverageIssueAgeBoardlessRoute: InvariantJiraRoute = {
	name: 'software-reports-average-issue-age-cmp-boardless',
	path: '/jira/software/c/projects/:projectKey/reports/average-age',
};
